module.exports = {"id":"226203","name":"Joevin Jones","rating":"74","photo":"./data/images/photos/0/226203.png","club":{"name":"SV Darmstadt","logo":"./data/images/clubs/SVDarmstadt.png"},"positions":["MG","DG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoevinJones0.json
// module id = 2061
// module chunks = 0